import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCursor1"><Path d="M4.6495 2.71804C3.44875 2.29207 2.29109 3.44972 2.71706 4.65047L8.54982 21.0922C9.00468 22.3744 10.7886 22.4522 11.3532 21.2144L14.3668 14.6085C14.4154 14.5019 14.5009 14.4164 14.6075 14.3678L21.2134 11.3542C22.4512 10.7895 22.3735 9.00565 21.0913 8.55079L4.6495 2.71804Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor1;
